import styled from 'styled-components';

import { Select } from '@dreryk/react-components';

export const StyledDosageUnitsSelect = styled(Select)`
   align-self: stretch;
` as typeof Select;
